const steps = [
  { num: "01", title: "Discover", desc: "Listening closely to understand each clinic's unique challenges." },
  { num: "02", title: "Analyze", desc: "Assessing, evaluating and identifying key opportunities." },
  { num: "03", title: "Strategize", desc: "Building a tailored plan aligned with defined goals." },
  { num: "04", title: "Implement", desc: "Partnering with internal teams to deliver measurable results." },
];

export default function OurApproach() {
  return (
    <section id="approach" className="bg-[#0e0e0e] text-white py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-start">
        {/* Left */}
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4 mb-8">
            <span className="text-[11px] tracking-[0.3em] tinde-gold uppercase">Our Approach</span>
            <span className="w-10 h-px tinde-gold-bg"></span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl leading-[1.15] mb-8">
            Strategic. Personalized. Tailored.
          </h2>
          <p className="text-[#bdbdbd] leading-relaxed max-w-md">
            A hands-on, customized approach to every partnership. Every clinic is unique&mdash;solutions are crafted around defined goals, dedicated teams, and patient needs.
          </p>
        </div>

        {/* Right steps */}
        <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-6 relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-[26px] left-[10%] right-[10%] h-px bg-[#3a3a3a]"></div>

          {steps.map((s, i) => (
            <div key={i} className="approach-step relative z-10">
              <div className="step-circle w-[52px] h-[52px] rounded-full border tinde-gold-border flex items-center justify-center mb-6 bg-[#0e0e0e]">
                <span className="text-xs tracking-[0.15em] tinde-gold">{s.num}</span>
              </div>
              <h4 className="text-[13px] tracking-[0.25em] uppercase font-medium mb-4">{s.title}</h4>
              <p className="text-sm text-[#a8a8a8] leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
